import { html, utl_renderObjects, utl_handleModalClose } from "../base/_utils";
import { staff } from "../data/_staff";
import staffCard from "../components/templates/_staff-card";
import "bootstrap/js/dist/modal";

document.addEventListener("DOMContentLoaded", () => {
    // Render staff card/modal for each member in _staff.js
    utl_renderObjects({
        data: staff,
        template: (member) => html`<div class="col-10 offset-1 col-sm-6 offset-sm-0 col-md-4 offset-md-0 col-xl-4 offset-xl-0 mt-4">${staffCard(member, "../../")}</div>`,
        target: "#staffContainer",
    });

    utl_handleModalClose();
});
